import { render } from "./Chevron.vue?vue&type=template&id=0acf958e"
const script = {}

import "./Chevron.vue?vue&type=style&index=0&id=0acf958e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__